import styled from 'styled-components/macro';
import { INDENT } from '@yme/tokens/sizes';
export const HeroSectionThemeStyled = styled.div `
  padding: ${INDENT.sm} 0;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
